import { create } from "zustand";
import { persist } from "zustand/middleware";

type State = {
  required: boolean;
  pendingVersion: string | null;
  acceptedVersion: string | null;
};

type Actions = {
  setTcRequired: (pendingVersion: string) => void;
  setAcceptedVersion: (version: string) => void;
  clearTcGate: () => void;
};

// acceptedVersion is intentionally excluded so clearTcGate does not wipe it —
// it must survive gate dismissal so useTcVersionCheck can compare on the next mount.
const gateInitialState = {
  required: false,
  pendingVersion: null,
};

export const useTcGateState = create<State & Actions>()(
  persist(
    (set) => ({
      ...gateInitialState,
      acceptedVersion: null,
      setTcRequired: (pendingVersion) =>
        set({ required: true, pendingVersion }),
      setAcceptedVersion: (version) => set({ acceptedVersion: version }),
      clearTcGate: () => set(gateInitialState),
    }),
    { name: "tc-gate-state" },
  ),
);
